import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { DataService } from "../../core/core-services/services/dataservices/data.service";
import { LoadingService } from "src/app/components/loading/loading.service";

@Injectable()
export class SettingsResolver  {
  constructor(private dataService: DataService, private router: Router, private loadingService: LoadingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    // this.loadingService.show();
    return this.dataService.get({ url: "v1/user/setting", isLoader: false }).pipe(
      catchError((error) => {
        this.router.navigate(["/session/error"]);
        return of(null);
      }),
      finalize(() => {
        // this.loadingService.hide()
      })
    );
  }
}
